export default __webpack_public_path__ + "static/media/gp-coin.e33992ab.webp";